export { joinPatterns } from './lib/join.js';
